"use client";

import { Mic, MessageSquare } from "lucide-react";
import { cn } from "@/lib/utils";

export type ModeToggleProps = {
  mode: "voice" | "chat";
  onModeChange: (mode: "voice" | "chat") => void;
};

export default function ModeToggle({ mode, onModeChange }: ModeToggleProps) {
  return (
    <div className="border-b border-[#e99bad]/10 px-4 py-3">
      <div className="mx-auto flex w-fit rounded-full bg-[#e99bad]/10 p-1">
        <button
          onClick={() => onModeChange("voice")}
          className={cn(
            "flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition-all duration-200",
            mode === "voice"
              ? "bg-white text-[#e99bad] shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          )}
        >
          <Mic className="h-3.5 w-3.5" />
          ボイスモード
        </button>
        <button
          onClick={() => onModeChange("chat")}
          className={cn(
            "flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition-all duration-200",
            mode === "chat"
              ? "bg-white text-[#e99bad] shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          )}
        >
          <MessageSquare className="h-3.5 w-3.5" />
          チャットモード
        </button>
      </div>
    </div>
  );
}
